import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import s from './LoginModal.scss';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

class LoginModal extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isChecked: false,
    };
    this.onCheck = this.onCheck.bind(this);
  }

  onCheck = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  }
  render() {
    return (
      <Modal show={this.props.showModal} onHide={this.props.close}>
        <Modal.Body>
          <div className="row">
            <div className="col-xs-2" />
            <div className="col-xs-8">
              <div className={"form-wrap"}>
                <h1>Zaloguj z użyciem email</h1>
                <form role="form">
                  <div className={"form-group"}>
                    <label htmlFor="email" className="sr-only">Email</label>
                    <input onChange={this.props.onChangeModalUser} type="email" name="email" id="email" className={"form-control"} placeholder="nazwa@przyklad.pl" />
                  </div>
                  <div className={"form-group"}>
                    <label htmlFor="key" className="sr-only">Password</label>
                    <input onChange={this.props.onChangeModalPasswd}  type={ this.state.isChecked ? '' : 'password'} name="key" id="key" className={"form-control"} placeholder="Hasło" />
                  </div>
                  <div className="checkbox">
                    <span onClick={this.onCheck} className={"character-checkbox"}>{ this.state.isChecked ? <i className={"glyphicon glyphicon-ok"} /> : ''}</span>
                    <span className="label">Pokaż hasło</span>
                  </div>
                  {this.props.hasError ? <p className="error"> {this.props.hasError} </p> : null}
                  <input onClick={this.props.logIn} type="submit" id="btn-login" className={"btn btn-custom btn-lg btn-block"} value="Log in" />
                </form>
                <a className={"forget"} data-toggle="modal" data-target=".forget-modal">Zapomniałeś hasła?</a>
              </div>
            </div>
            <div className="col-xs-2" />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withStyles(s)(LoginModal);



// WEBPACK FOOTER //
// src/components/Modals/LoginModal/LoginModal.js